import { BuildingDTO } from "./building";
import { Resource } from "./resource";
import { UnitDTO } from "./unit";

// THIS IS THE DATBASE QUERY SO MAKE SURE IT CONTAINS ANY OF THESE FOR PICTURES
/*
qb.where("fileLog.label ILIKE :label1", { label1: '%foto%' })
.orWhere("fileLog.label ILIKE :label2", { label2: '%Foto%' })
.orWhere("fileLog.label ILIKE :label3", { label3: '%Picture%' })
.orWhere("fileLog.label ILIKE :label4", { label4: '%picture%' })
.orWhere("fileLog.label ILIKE :label4", { label4: '%beelden%' });
*/

export enum SecondaryLabel {
  COMMERCIEEL = "Commercieel",
  INGOING_PLACE_DESCRIPTION = "Plaatsbeschrijving",
  RENOVATIE = "Renovatieproject",
  ACQUISITIEFICHE = "Acquisitiefiche",
}

export enum UnitPictureLabels {
  PictureRenovationWorksUnit = "Foto werfopvolging unit",
  FrontagePictureUnit = "Foto voorgevel unit",
  DevicePictureUnit = "Foto toestel unit",
  MoistPictureUnit = "Foto vochtproblemen unit",
  AsbestosMaterialsPictureUnit = "Foto asbesthoudende materialen unit",
  StabilityPictureUnitCracksAndFissures = "Foto stabiliteit unit - scheuren of barsten",
  PictureBedrooms = "Foto slaapkamers",
  PictureBathroom = "Foto badkamer",
  PictureToilet = "Foto toilet",
  CeilingFloorWallsPicture = "Foto muren - ramen - plafond afwerking",
  PictureElectricalInstallationUnit = "Foto elektrische installatie unit",
  PictureClimatisationDevice = "Foto klimatisatie toestel",
  PictureKitchen = "Foto keuken",
  PictureLivingRoom = "Foto leefruimte",
  PictureStorage = "Foto berging",
  PictureCentralHeatingUnit = "Foto verwarmingsinstallatie unit",
  PictureWaterMeterUnit = "Foto watermeter unit",
  PictureElectricityMeterUnit = "Foto elektriciteitsmeter unit",
  PictureGasMeterUnit = "Foto gasmeter unit",
  PictureTerrace = "Foto terras",
  PictureGarden = "Foto tuin",
  PictureKeysFrontDoor = "Foto sleutel voordeur",
  PictureKeysApartment = "Foto sleutel appartement",
  PictureKeysLetterbox = "Foto sleutel brievenbus",
  PictureCommercialUnit = "Foto winkelruimte",
  PictureAlarmInstallationUnit = "Foto alarminstallatie unit",
  PictureFireSecurityUnit = "Foto brandveiligheid unit",
  Income = "Foto inkomhal unit",
  BedroomOne = "Foto slaapkamer 1",
  BedroomTwo = "Foto slaapkamer 2",
  BedroomThree = "Foto slaapkamer 3",
  BedroomFour = "Foto slaapkamer 4",
}

export enum BuildingPictureLabels {
  PictureStateBeforeWorks = "Foto staat voor renovatiewerken",
  OldPicturesHistorical = "Foto historisch - beelden van vroeger",
  AcquisitionImages = "Acquisitiebeelden",
  FrontagePicture = "Foto voorgevel gebouw",
  SideFacadeLeftPicture = "Foto zijgevel links",
  SideFacadeRightPicture = "Foto zijgevel rechts",
  BackFacadePicture = "Foto achtergevel",
  MainRoofPicture = "Foto hoofddak",
  SideRoofPicture = "Foto bijdak",
  AsbestosMaterialsPicture = "Foto asbesthoudende materialen gebouw",
  MoistPicture = "Foto vochtproblemen gebouw",
  StabilityPictureCracksAndFissures = "Foto stabiliteit gebouw - scheuren of barsten",
  PictureStairsCommonHall = "Foto trappen gemeenschap",
  PictureElectricalInstallation = "Foto elektrische installatie gebouw",
  FotoWerfopvolging = "Foto werfopvolging",
  ElektriciteitFotosUitvoering = "Elektriciteit foto's uitvoering",
  ElevatorPicture = "Foto lift",
  SewagePicture = "Foto riolering",
  PictureGutter = "Foto dakgoot",
  PictureRainwaterPipe = "Foto regenwaterafvoer",
  PictureDoorbell = "Foto deurbel",
  PictureRenovationSiteMonitoring = "Foto Renovatie - Werfopvolging",
  WindowsFrontPicture = "Foto ramen voorgevel",
  WindowsBackPicture = "Foto ramen achtergevel",
  WindowsLeftPicture = "Foto ramen zijgevel links",
  WindowsRightPicture = "Foto ramen zijgevel rechts",
  PictureCellar = "Foto kelder",
  PictureWaterMeterBuilding = "Foto watermeter gebouw",
  PictureElectricityMeterBuilding = "Foto elektriciteitsmeter gebouw",
  PictureGasMeterBuilding = "Foto gasmeter gebouw",
  PictureGarage = "Foto garage",
  PictureHal = "Foto inkomhal",
  PictureKeyCard = "Foto sleutelkaart",
  PictureNeighboringBuildings = "Foto aangrenzende gebouwen",
  PictureNeighbourhood = "Foto omgeving",
  PictureCollectiveCentralHeatingBuilding = "Foto collectieve verwarmingsinstallatie gebouw",
  PictureFireSecurityBuilding = "Foto brandveiligheid gebouw",
  PictureAlarmInstallationBuilding = "Foto alarminstallatie gebouw",
}

export enum PictureLabel {
  PictureRenovationWorksUnit = "Foto werfopvolging unit",
  PictureStateBeforeWorks = "Foto staat voor renovatiewerken",
  CoverImage = "Cover foto",
  OldPicturesHistorical = "Foto historisch - beelden van vroeger",
  BuildingCoverImage = "Cover foto gebouw",
  UnitCoverImage = "Cover foto unit",
  AcquisitionImages = "Acquisitiebeelden",
  FrontagePicture = "Foto voorgevel gebouw",
  SideFacadeLeftPicture = "Foto zijgevel links",
  SideFacadeRightPicture = "Foto zijgevel rechts",
  BackFacadePicture = "Foto achtergevel",
  MainRoofPicture = "Foto hoofddak",
  SideRoofPicture = "Foto bijdak",
  AsbestosMaterialsPicture = "Foto asbesthoudende materialen gebouw",
  MoistPicture = "Foto vochtproblemen gebouw",
  StabilityPictureCracksAndFissures = "Foto stabiliteit gebouw - scheuren of barsten",
  PictureStairsCommonHall = "Foto trappen gemeenschap",
  PictureElectricalInstallation = "Foto elektrische installatie gebouw",
  FotoWerfopvolging = "Foto werfopvolging",
  ElektriciteitFotosUitvoering = "Elektriciteit foto's uitvoering",
  ElevatorPicture = "Foto lift",
  SewagePicture = "Foto riolering",
  PictureGutter = "Foto dakgoot",
  PictureRainwaterPipe = "Foto regenwaterafvoer",
  PictureDoorbell = "Foto deurbel",
  PictureRenovationSiteMonitoring = "Foto Renovatie - Werfopvolging",
  WindowsFrontPicture = "Foto ramen voorgevel",
  WindowsBackPicture = "Foto ramen achtergevel",
  WindowsLeftPicture = "Foto ramen zijgevel links",
  WindowsRightPicture = "Foto ramen zijgevel rechts",
  PictureCellar = "Foto kelder",
  PictureWaterMeterBuilding = "Foto watermeter gebouw",
  PictureElectricityMeterBuilding = "Foto elektriciteitsmeter gebouw",
  PictureGasMeterBuilding = "Foto gasmeter gebouw",
  PictureGarage = "Foto garage",
  PictureHal = "Foto inkomhal",
  PictureKeyCard = "Foto sleutelkaart",
  PictureNeighboringBuildings = "Foto aangrenzende gebouwen",
  PictureNeighbourhood = "Foto omgeving",
  PictureCollectiveCentralHeatingBuilding = "Foto collectieve verwarmingsinstallatie gebouw",
  PictureFireSecurityBuilding = "Foto brandveiligheid gebouw",
  PictureAlarmInstallationBuilding = "Foto alarminstallatie gebouw",
  FrontagePictureUnit = "Foto voorgevel unit",
  DevicePictureUnit = "Foto toestel unit",
  MoistPictureUnit = "Foto vochtproblemen unit",
  AsbestosMaterialsPictureUnit = "Foto asbesthoudende materialen unit",
  StabilityPictureUnitCracksAndFissures = "Foto stabiliteit unit - scheuren of barsten",
  PictureBedrooms = "Foto slaapkamers",
  PictureBathroom = "Foto badkamer",
  PictureToilet = "Foto toilet",
  CeilingFloorWallsPicture = "Foto muren - ramen - plafond afwerking",
  PictureElectricalInstallationUnit = "Foto elektrische installatie unit",
  PictureClimatisationDevice = "Foto klimatisatie toestel",
  PictureKitchen = "Foto keuken",
  PictureLivingRoom = "Foto leefruimte",
  PictureStorage = "Foto berging",
  PictureCentralHeatingUnit = "Foto verwarmingsinstallatie unit",
  PictureWaterMeterUnit = "Foto watermeter unit",
  PictureElectricityMeterUnit = "Foto elektriciteitsmeter unit",
  PictureGasMeterUnit = "Foto gasmeter unit",
  PictureTerrace = "Foto terras",
  PictureGarden = "Foto tuin",
  PictureKeysFrontDoor = "Foto sleutel voordeur",
  PictureKeysApartment = "Foto sleutel appartement",
  PictureKeysLetterbox = "Foto sleutel brievenbus",
  PictureCommercialUnit = "Foto winkelruimte",
  PictureAlarmInstallationUnit = "Foto alarminstallatie unit",
  PictureFireSecurityUnit = "Foto brandveiligheid unit",
  Income = "Foto inkomhal unit",
  BedroomOne = "Foto slaapkamer 1",
  BedroomTwo = "Foto slaapkamer 2",
  BedroomThree = "Foto slaapkamer 3",
  BedroomFour = "Foto slaapkamer 4",
}

export enum UnitDocumentLabels {
  JusticeOfPeaceDeed = "Vonnis - Vredegerecht",
  JusticeOfPeaceCommunication = "Communicatie - Vredegerecht",
  JusticeOfPeaceSummons = "Dagvaarding - Vredegerecht",
  CommunicationLawyerCounterparty = "Communicatie huurgeschil - Advocaat huurder",
  CommunicationLawyerOwn = "Communicatie huurgeschil - Eigen advocaat",
  BundleJusticeOfPeace = "Huurgeschil - stukkenbundel intern",
  BundleLawyerCounterparty = "Huurgeschil - stukkenbundel huurder",
  JusticeOfPeaceRequest = "Vredegerecht - Verzoeksschrift",
  EPCUnit = "EPC unit",
  Huurcontract = "Huurcontract",
  AddendumHuurcontract = "Addendum aan huurcontract",
  GarageAddendumContract = "Garage addendum contract",
  AnnexHuurcontract = "Bijlage aan huurcontract",
  CommunicatieHuurder = "Communicatie huurder",
  BetalingsbewijsHuur = "Betalingsbewijs huur",
  BewijsVanWerk = "Bewijs van werk",
  BrandverzekeringHuurder = "Brandverzekering huurder",
  Huurhernieuwingsaanvraag = "Huurhernieuwingsaanvraag",
  Huurwaarborg = "Huurwaarborg",
  IdentiteitskaartHuurder = "Identiteitskaart huurder",
  Indexatiebrief = "Indexatiebrief",
  IngaandePlaatsbeschrijving = "Ingaande plaatsbeschrijving",
  Loonfiche = "Loonfiche",
  Opzegbrief = "Opzegbrief",
  RegistratiebewijsHuurcontract = "Registratiebewijs huurcontract",
  RegistratiebewijsPlaatsbeschrijving = "Registratiebewijs plaatsbeschrijving",
  ReglementInwendigeOrde = "Reglement inwendige orde",
  Sleuteloverdracht = "Sleuteloverdracht",
  UitgaandePlaatsbeschrijving = "Uitgaande plaatsbeschrijving",
  ElektriciteitSituatieschetsUnit = "Elektriciteit situatieschets unit",
  ElektriciteitEendraadsschemaUnit = "Elektriciteit eendraadsschema unit",
  ElektriciteitKeuringsattestUnit = "Elektriciteit keuringsattest unit",
  VerwarmingKeuringsattest = "Verwarming unit keuringsattest",
  VerwarmingOnderhoudsattest = "Verwarming unit onderhoudsattest",
  PlanUnitCommercieel = "Plan unit commercieel",
  PlanUnitHuidigeIndeling = "Plan unit huidige indeling",
  PlanUnitOntwerpNieuweIndeling = "Plan unit ontwerp nieuwe indeling",
  ConformiteitsattestUnit = "Conformiteitsattest unit",
  ToestelBestelbon = "Toestel bestelbon",
  ToestelFactuur = "Toestel factuur",
  ToestelFiche = "Toestel fiche",
  ToestelGarantiebewijs = "Toestel garantiebewijs",
  ToestelHandleiding = "Toestel handleiding",
  ToestelOfferte = "Toestel offerte",
}

export enum BuildingDocumentLabels {
  OwnershipRemovalPlan = "Onteigeningsplan",
  DescriptionBeforeRenovation = "Plaatsbeschrijving voor start renovatiewerken",
  OfferFacadeWorks = "Gevelwerken - Offerte",
  InvoiceFacadeWorks = "Gevelwerken - Factuur",
  AircoOffer = "HVAC - Offerte",
  InspectionGasInstallationBuilding = "Keuring gebouw gasinstallatie - gasaansluiting",
  AircoInvoice = "HVAC - Factuur",
  BathroomworksOffer = "Badkamerwerken - Offerte",
  BathroomworksInvoice = "Badkamerwerken - Factuur",
  KitchenWorksOffer = "Keukenwerken - Offerte",
  KitchenWorks = "Keukenwerken - Factuur",
  StaircaseWorks = "Trappen werken - Factuur",
  StaircaseOffer = "Trappen werken - Offerte",
  OfferBalconyWorks = "Balkonwerken - Offerte",
  InvoiceBalconyWorks = "Balkonwerken - Factuur",
  OfferSewageWorks = "Rioleringswerken - Offerte",
  InvoiceSewageWorks = "Rioleringswerken - Factuur",
  SepticalTankOffer = "Septische put - Offerte",
  SepticalTankInvoice = "Septische put - Factuur",
  SepticalTankWorksInvoice = "Septische put onderhoudswerken - Factuur",
  SepticalTankCleaningInvoice = "Septische put reinigingswerken - Factuur",
  RenovationOtherCapex = "Andere kleine herstellingen - Factuur",
  CommunicationNotary = "Communicatie - Notaris",
  RoofTechnicalFileWaterproofing = "Dak - Technische fiche - Waterdichting",
  RoofTechnicalFileInsulation = "Dak - Technische fiche - Isolatie",
  RoofTechnicalFileRoofStructure = "Dak - Technische fiche - Dakstructuur",
  RoofTechnicalFileRoofCovering = "Dak - Technische fiche - Dakbedekking",
  RoofTechnicalFileRoofWindows = "Dak - Technische fiche - Dakramen",
  RoofWorkInvoices = "Dak - Facturen werken",
  RoofWorkOffers = "Dak - Offertes werken",
  PIDOverviewContractors = "Postinterventie - Overzicht aannemers",
  InsuranceFileCommunication = "Verzekeringsdossier - Communicatie verzekeringsmaatschappij",
  InsuranceFileCommunicationCounterparty = "Verzekeringsdossier - Communicatie tegenpartij",
  InsuranceFileExpertiseReport = "Verzekeringsdossier - Expertiseverslag",
  InsuranceFileInfringement = "Verzekeringsdossier - Schade ingebrekestelling",
  CleaningServiceContract = "Poetsdienst - Contract",
  PermitAssumptionProof = "Vermoeden van vergunning - bewijsstuk",
  FireSecurityReviewAndInspection = "Brandveiligheid - Nazicht en keuring",
  KeysKeyPlanInvoice = "Slotenplan - Sleutels - Factuur",
  ElectricityWorksInvoice = "Elektriciteit werken - Factuur",
  ElectricityWorksOffer = "Elektriciteit werken - Offerte",
  SanitoryWorksInvoice = "Sanitair werken - Factuur",
  SanitoryWorksOffer = "Sanitair werken - Offerte",
  PaintingWorksInvoice = "Schilderwerken - Factuur",
  FinalProvisionStatementNotaryDeed = "Aankoop - Eindafrekening notaris",
  SolarPanelsOffer = "Zonnepanelen - Offerte",
  SolarPanelsCalculationCapacity = "Zonnepanelen - Berekening capaciteit",
  SolarPanelsInvoice = "Zonnepanelen - Factuur",
  TransferEnergy = "Aankoop - Overdracht energie vorige eigenaar",
  TransferWater = "Aankoop - Overdracht water vorige eigenaar",
  RequestTakePublicDomain = "Aanvraag inname openbaar domein",
  SignalisationPermit = "Signalisatievergunning voor werken",
  OfferNewFrontDoor = "Offerte plaatsen nieuwe voordeur",
  InvoiceNewFrontDoor = "Factuur plaatsen nieuwe voordeur",
  InvoiceRepairInsuredDamage = "Verzekeringsdossier - Factuur herstelling schade",
  OfferRepairInsuredDamage = "Verzekeringsdossier - Offerte herstelling schade",
  OfferNewWindows = "Offerte plaatsen nieuwe ramen",
  InvoiceNewWindows = "Factuur plaatsen nieuwe ramen",
  RequestPermitAssumed = "Aanvraag vergund geacht - vermoeden van vergunning",
  Aannemers = "Aannemers",
  AsbestosRemovalInvoice = "Asbest factuur verwijdering",
  Gebouwfiche = "Gebouwfiche",
  TaxatieBerekeningen = "Berekeningen taxatie",
  OnderhandseOvereenkomst = "Onderhandse overeenkomst aankoop gebouw",
  Brandvoorschriften = "Brand voorschriften",
  ConformiteitsattestBrandveiligheid = "Conformiteitsattest brandveiligheid",
  Evacuatieplan = "Evacuatieplan",
  PVOvertredingBrand = "PV overtreding brand",
  EnergeticalDD = "Energetical DD",
  FinancialDD = "Financial DD",
  FiscalDD = "Fiscal DD",
  LegalDD = "Legal DD",
  TechnicalDD = "Technical DD",
  Financieel = "Financieel",
  AanslagbiljetOV = "Aanslagbiljet OV",
  AttestAankoop = "Attest aankoop",
  StabilityStudy = "Stabiliteit - Stabiliteitsstudie",
  StabilityCommunication = "Stabiliteit - Communicatie",
  StabilityReportVisit = "Stabiliteit - Rapportage plaatsbezoek",
  Basisakte = "Basisakte",
  Eigendomsakte = "Eigendomsakte",
  KadastraalInkomen = "Kadastraal inkomen",
  ReglementMedeEigendom = "Reglement mede eigendom",
  SchattingTaxatieverslag = "Schatting taxatieverslag",
  SPA = "SPA",
  EPBDossier = "EPB dossier",
  EPCCommon = "EPC gemeenschap",
  Renovaties = "Renovaties",
  CollectieveVerwarmingKeuringsattest = "Collectieve verwarming keuringsattest",
  CollectieveVerwarmingOnderhoudsattest = "Collectieve verwarming onderhoudsattest",
  CollectieveVerwarmingToestelfiche = "Collectieve verwarming toestelfiche",
  CollectieveVerwarmingFactuur = "Collectieve verwarming factuur",
  BBO = "BBO",
  Bodemattest = "Bodemattest",
  Grondanalyse = "Grondanalyse",
  Omgevingsvergunning = "Omgevingsvergunning",
  Bouwaanvraag = "Bouwaanvraag",
  Milieuvergunning = "Milieuvergunning",
  OBO = "OBO",
  Aanbesteding = "Aanbesteding",
  Budget = "Budget",
  Lastenboek = "Lastenboek",
  Materialenfiche = "Materialenfiche",
  RioleringKeuringsattest = "Keuringsattest riolering gebouw",
  Rioleringsplan = "Plan riolering",
  WaterKeuringBinneninstallatie = "Keuringsattest binneninstallatie water",
  Opleveringsverslag = "Opleveringsverslag werken",
  Veiligheidscoordinatie = "Verslag veiligheidscoordinatie",
  Werfverslag = "Werfverslag",
  ElektriciteitSituatieschetsBuilding = "Elektriciteit situatieschets gebouw",
  ElektriciteitEendraadsschemaGebouw = "Elektriciteit eendraadsschema gebouw",
  ElektriciteitAlgemeen = "Elektriciteit algemeen",
  ElektriciteitKeuringsattestGebouw = "Elektriciteit keuringsattest gebouw",
  Lift = "Lift",
  ElevatorRiskAnalysis = "Lift risicoanalyse",
  ElevatorMaintenanceContract = "Lift onderhoudscontract",
  ElevatorInspectionCertificate = "Lift keuringsattest",
  PlanCommercieel = "Plan commercieel",
  PlanKadaster = "Plan kadaster",
  PlanLandmeter = "Plan landmeter",
  PlanUitvoering = "Plan uitvoering",
  PlanVergunning = "Plan vergunning",
  PlanVoorontwerp = "Plan voorontwerp",
  PlanGeneriek = "Plan generiek",
  PlanVoorstelNieuweToestand = "Plan voorstel nieuwe toestand",
  Biedbrief = "Biedbrief",
  LOI = "LOI",
  Bouwvoorschriften = "Bouwvoorschriften",
  ConformiteitsattestStedenbouw = "Conformiteitsattest stedenbouw",
  PVOvertredingStedenbouw = "PV overtreding stedenbouw",
  StedenbouwkundigeInlichtingen = "Stedenbouwkundige inlichtingen",
  Vergunning = "Vergunning",
  Asbestattest = "Asbestattest gemeenschappelijke delen",
  Asbestinventaris = "Asbestinventaris",
  GevaarlijkeStoffen = "Gevaarlijke stoffen",
  ABRPolis = "ABR polis",
  VerzekeringCommunicatie = "Verzekering communicatie",
  Verzekeringsattest = "Verzekeringsattest",
  Verzekeringspolis = "Verzekeringspolis",
  OverigeToestellenGemeenschap = "Overige toestellen gemeenschap",
  Nutsvoorzieningen = "Nutsvoorzieningen",
  KadastraalUittreksel = "Kadastraal uittreksel",
}

export enum DocumentLabel {
  OwnershipRemovalPlan = "Onteigeningsplan",
  DescriptionBeforeRenovation = "Plaatsbeschrijving voor start renovatiewerken",
  OfferFacadeWorks = "Gevelwerken - Offerte",
  InvoiceFacadeWorks = "Gevelwerken - Factuur",
  AircoOffer = "HVAC - Offerte",
  InspectionGasInstallationBuilding = "Keuring gebouw gasinstallatie - gasaansluiting",
  AircoInvoice = "HVAC - Factuur",
  BathroomworksOffer = "Badkamerwerken - Offerte",
  BathroomworksInvoice = "Badkamerwerken - Factuur",
  KitchenWorksOffer = "Keukenwerken - Offerte",
  KitchenWorks = "Keukenwerken - Factuur",
  StaircaseWorks = "Trappen werken - Factuur",
  StaircaseOffer = "Trappen werken - Offerte",
  OfferBalconyWorks = "Balkonwerken - Offerte",
  InvoiceBalconyWorks = "Balkonwerken - Factuur",
  OfferSewageWorks = "Rioleringswerken - Offerte",
  InvoiceSewageWorks = "Rioleringswerken - Factuur",
  SepticalTankOffer = "Septische put - Offerte",
  SepticalTankInvoice = "Septische put - Factuur",
  SepticalTankWorksInvoice = "Septische put onderhoudswerken - Factuur",
  SepticalTankCleaningInvoice = "Septische put reinigingswerken - Factuur",
  RenovationOtherCapex = "Andere kleine herstellingen - Factuur",
  InvoiceRepairInsuredDamage = "Verzekeringsdossier - Factuur herstelling schade",
  OfferRepairInsuredDamage = "Verzekeringsdossier - Offerte herstelling schade",
  JusticeOfPeaceDeed = "Vonnis - Vredegerecht",
  JusticeOfPeaceCommunication = "Communicatie - Vredegerecht",
  JusticeOfPeaceSummons = "Dagvaarding - Vredegerecht",
  CommunicationLawyerCounterparty = "Communicatie huurgeschil - Advocaat huurder",
  CommunicationLawyerOwn = "Communicatie huurgeschil - Eigen advocaat",
  BundleJusticeOfPeace = "Huurgeschil - stukkenbundel intern",
  BundleLawyerCounterparty = "Huurgeschil - stukkenbundel huurder",
  JusticeOfPeaceRequest = "Vredegerecht - Verzoeksschrift",
  CommunicationNotary = "Communicatie - Notaris",
  RoofTechnicalFileWaterproofing = "Dak - Technische fiche - Waterdichting",
  RoofTechnicalFileInsulation = "Dak - Technische fiche - Isolatie",
  RoofTechnicalFileRoofStructure = "Dak - Technische fiche - Dakstructuur",
  RoofTechnicalFileRoofCovering = "Dak - Technische fiche - Dakbedekking",
  RoofTechnicalFileRoofWindows = "Dak - Technische fiche - Dakramen",
  RoofWorkInvoices = "Dak - Facturen werken",
  RoofWorkOffers = "Dak - Offertes werken",
  PIDOverviewContractors = "Postinterventie - Overzicht aannemers",
  InsuranceFileCommunication = "Verzekeringsdossier - Communicatie verzekeringsmaatschappij",
  InsuranceFileCommunicationCounterparty = "Verzekeringsdossier - Communicatie tegenpartij",
  InsuranceFileExpertiseReport = "Verzekeringsdossier - Expertiseverslag",
  InsuranceFileInfringement = "Verzekeringsdossier - Schade ingebrekestelling",
  CleaningServiceContract = "Poetsdienst - Contract",
  PermitAssumptionProof = "Vermoeden van vergunning - bewijsstuk",
  FireSecurityReviewAndInspection = "Brandveiligheid - Nazicht en keuring",
  KeysKeyPlanInvoice = "Slotenplan - Sleutels - Factuur",
  ElectricityWorksInvoice = "Elektriciteit werken - Factuur",
  ElectricityWorksOffer = "Elektriciteit werken - Offerte",
  SanitoryWorksInvoice = "Sanitair werken - Factuur",
  SanitoryWorksOffer = "Sanitair werken - Offerte",
  PaintingWorksInvoice = "Schilderwerken - Factuur",
  FinalProvisionStatementNotaryDeed = "Aankoop - Eindafrekening notaris",
  SolarPanelsOffer = "Zonnepanelen - Offerte",
  SolarPanelsCalculationCapacity = "Zonnepanelen - Berekening capaciteit",
  SolarPanelsInvoice = "Zonnepanelen - Factuur",
  TransferEnergy = "Aankoop - Overdracht energie vorige eigenaar",
  TransferWater = "Aankoop - Overdracht water vorige eigenaar",
  RequestTakePublicDomain = "Aanvraag inname openbaar domein",
  SignalisationPermit = "Signalisatievergunning voor werken",
  OfferNewFrontDoor = "Offerte plaatsen nieuwe voordeur",
  InvoiceNewFrontDoor = "Factuur plaatsen nieuwe voordeur",
  OfferNewWindows = "Offerte plaatsen nieuwe ramen",
  InvoiceNewWindows = "Factuur plaatsen nieuwe ramen",
  RequestPermitAssumed = "Aanvraag vergund geacht - vermoeden van vergunning",
  Aannemers = "Aannemers",
  AsbestosRemovalInvoice = "Asbest factuur verwijdering",
  Gebouwfiche = "Gebouwfiche",
  TaxatieBerekeningen = "Berekeningen taxatie",
  OnderhandseOvereenkomst = "Onderhandse overeenkomst aankoop gebouw",
  Brandvoorschriften = "Brand voorschriften",
  ConformiteitsattestBrandveiligheid = "Conformiteitsattest brandveiligheid",
  Evacuatieplan = "Evacuatieplan",
  PVOvertredingBrand = "PV overtreding brand",
  EnergeticalDD = "Energetical DD",
  FinancialDD = "Financial DD",
  FiscalDD = "Fiscal DD",
  LegalDD = "Legal DD",
  TechnicalDD = "Technical DD",
  Financieel = "Financieel",
  AanslagbiljetOV = "Aanslagbiljet OV",
  AttestAankoop = "Attest aankoop",
  StabilityStudy = "Stabiliteit - Stabiliteitsstudie",
  StabilityCommunication = "Stabiliteit - Communicatie",
  StabilityReportVisit = "Stabiliteit - Rapportage plaatsbezoek",
  Basisakte = "Basisakte",
  Eigendomsakte = "Eigendomsakte",
  KadastraalInkomen = "Kadastraal inkomen",
  ReglementMedeEigendom = "Reglement mede eigendom",
  SchattingTaxatieverslag = "Schatting taxatieverslag",
  SPA = "SPA",
  EPBDossier = "EPB dossier",
  EPCCommon = "EPC gemeenschap",
  Renovaties = "Renovaties",
  CollectieveVerwarmingKeuringsattest = "Collectieve verwarming keuringsattest",
  CollectieveVerwarmingOnderhoudsattest = "Collectieve verwarming onderhoudsattest",
  CollectieveVerwarmingToestelfiche = "Collectieve verwarming toestelfiche",
  CollectieveVerwarmingFactuur = "Collectieve verwarming factuur",
  BBO = "BBO",
  Bodemattest = "Bodemattest",
  Grondanalyse = "Grondanalyse",
  Omgevingsvergunning = "Omgevingsvergunning",
  Bouwaanvraag = "Bouwaanvraag",
  Milieuvergunning = "Milieuvergunning",
  OBO = "OBO",
  Aanbesteding = "Aanbesteding",
  Budget = "Budget",
  Lastenboek = "Lastenboek",
  Materialenfiche = "Materialenfiche",
  RioleringKeuringsattest = "Keuringsattest riolering gebouw",
  Rioleringsplan = "Plan riolering",
  WaterKeuringBinneninstallatie = "Keuringsattest binneninstallatie water",
  Opleveringsverslag = "Opleveringsverslag werken",
  Veiligheidscoordinatie = "Verslag veiligheidscoordinatie",
  Werfverslag = "Werfverslag",
  ElektriciteitSituatieschetsBuilding = "Elektriciteit situatieschets gebouw",
  ElektriciteitEendraadsschemaGebouw = "Elektriciteit eendraadsschema gebouw",
  ElektriciteitAlgemeen = "Elektriciteit algemeen",
  ElektriciteitKeuringsattestGebouw = "Elektriciteit keuringsattest gebouw",
  Lift = "Lift",
  ElevatorRiskAnalysis = "Lift risicoanalyse",
  ElevatorMaintenanceContract = "Lift onderhoudscontract",
  ElevatorInspectionCertificate = "Lift keuringsattest",
  PlanCommercieel = "Plan commercieel",
  PlanKadaster = "Plan kadaster",
  PlanLandmeter = "Plan landmeter",
  PlanUitvoering = "Plan uitvoering",
  PlanVergunning = "Plan vergunning",
  PlanVoorontwerp = "Plan voorontwerp",
  PlanGeneriek = "Plan generiek",
  PlanVoorstelNieuweToestand = "Plan voorstel nieuwe toestand",
  Biedbrief = "Biedbrief",
  LOI = "LOI",
  Bouwvoorschriften = "Bouwvoorschriften",
  ConformiteitsattestStedenbouw = "Conformiteitsattest stedenbouw",
  PVOvertredingStedenbouw = "PV overtreding stedenbouw",
  StedenbouwkundigeInlichtingen = "Stedenbouwkundige inlichtingen",
  Vergunning = "Vergunning",
  Asbestattest = "Asbestattest gemeenschappelijke delen",
  Asbestinventaris = "Asbestinventaris",
  GevaarlijkeStoffen = "Gevaarlijke stoffen",
  ABRPolis = "ABR polis",
  VerzekeringCommunicatie = "Verzekering communicatie",
  Verzekeringsattest = "Verzekeringsattest",
  Verzekeringspolis = "Verzekeringspolis",
  OverigeToestellenGemeenschap = "Overige toestellen gemeenschap",
  Nutsvoorzieningen = "Nutsvoorzieningen",
  KadastraalUittreksel = "Kadastraal uittreksel",
  EPCUnit = "EPC unit",
  Huurcontract = "Huurcontract",
  AddendumHuurcontract = "Addendum aan huurcontract",
  GarageAddendumContract = "Garage addendum contract",
  AnnexHuurcontract = "Bijlage aan huurcontract",
  CommunicatieHuurder = "Communicatie huurder",
  BetalingsbewijsHuur = "Betalingsbewijs huur",
  BewijsVanWerk = "Bewijs van werk",
  BrandverzekeringHuurder = "Brandverzekering huurder",
  Huurhernieuwingsaanvraag = "Huurhernieuwingsaanvraag",
  Huurwaarborg = "Huurwaarborg",
  IdentiteitskaartHuurder = "Identiteitskaart huurder",
  Indexatiebrief = "Indexatiebrief",
  IngaandePlaatsbeschrijving = "Ingaande plaatsbeschrijving",
  Loonfiche = "Loonfiche",
  Opzegbrief = "Opzegbrief",
  RegistratiebewijsHuurcontract = "Registratiebewijs huurcontract",
  RegistratiebewijsPlaatsbeschrijving = "Registratiebewijs plaatsbeschrijving",
  ReglementInwendigeOrde = "Reglement inwendige orde",
  Sleuteloverdracht = "Sleuteloverdracht",
  UitgaandePlaatsbeschrijving = "Uitgaande plaatsbeschrijving",
  ElektriciteitSituatieschetsUnit = "Elektriciteit situatieschets unit",
  ElektriciteitEendraadsschemaUnit = "Elektriciteit eendraadsschema unit",
  ElektriciteitKeuringsattestUnit = "Elektriciteit keuringsattest unit",
  VerwarmingKeuringsattest = "Verwarming unit keuringsattest",
  VerwarmingOnderhoudsattest = "Verwarming unit onderhoudsattest",
  PlanUnitCommercieel = "Plan unit commercieel",
  PlanUnitHuidigeIndeling = "Plan unit huidige indeling",
  PlanUnitOntwerpNieuweIndeling = "Plan unit ontwerp nieuwe indeling",
  ConformiteitsattestUnit = "Conformiteitsattest unit",
  ToestelBestelbon = "Toestel bestelbon",
  ToestelFactuur = "Toestel factuur",
  ToestelFiche = "Toestel fiche",
  ToestelGarantiebewijs = "Toestel garantiebewijs",
  ToestelHandleiding = "Toestel handleiding",
  ToestelOfferte = "Toestel offerte",
}

export enum FileLabel {
  JusticeOfPeaceDeed = "Vonnis - Vredegerecht",
  JusticeOfPeaceCommunication = "Communicatie - Vredegerecht",
  JusticeOfPeaceSummons = "Dagvaarding - Vredegerecht",
  CommunicationLawyerCounterparty = "Communicatie huurgeschil - Advocaat huurder",
  CommunicationLawyerOwn = "Communicatie huurgeschil - Eigen advocaat",
  BundleJusticeOfPeace = "Huurgeschil - stukkenbundel intern",
  BundleLawyerCounterparty = "Huurgeschil - stukkenbundel huurder",
  JusticeOfPeaceRequest = "Vredegerecht - Verzoeksschrift",
  InspectionGasInstallationBuilding = "Keuring gebouw gasinstallatie - gasaansluiting",
  OwnershipRemovalPlan = "Onteigeningsplan",
  PictureRenovationWorksUnit = "Foto werfopvolging unit",
  PictureStateBeforeWorks = "Foto staat voor renovatiewerken",
  DescriptionBeforeRenovation = "Plaatsbeschrijving voor start renovatiewerken",
  OfferFacadeWorks = "Gevelwerken - Offerte",
  InvoiceFacadeWorks = "Gevelwerken - Factuur",
  AircoOffer = "HVAC - Offerte",
  AircoInvoice = "HVAC - Factuur",
  BathroomworksOffer = "Badkamerwerken - Offerte",
  BathroomworksInvoice = "Badkamerwerken - Factuur",
  KitchenWorksOffer = "Keukenwerken - Offerte",
  KitchenWorks = "Keukenwerken - Factuur",
  StaircaseWorks = "Trappen werken - Factuur",
  StaircaseOffer = "Trappen werken - Offerte",
  OfferBalconyWorks = "Balkonwerken - Offerte",
  InvoiceBalconyWorks = "Balkonwerken - Factuur",
  OfferSewageWorks = "Rioleringswerken - Offerte",
  InvoiceSewageWorks = "Rioleringswerken - Factuur",
  SepticalTankOffer = "Septische put - Offerte",
  SepticalTankInvoice = "Septische put - Factuur",
  SepticalTankWorksInvoice = "Septische put onderhoudswerken - Factuur",
  SepticalTankCleaningInvoice = "Septische put reinigingswerken - Factuur",
  RenovationOtherCapex = "Andere kleine herstellingen - Factuur",
  InvoiceRepairInsuredDamage = "Verzekeringsdossier - Factuur herstelling schade",
  OfferRepairInsuredDamage = "Verzekeringsdossier - Offerte herstelling schade",
  RoofTechnicalFileWaterproofing = "Dak - Technische fiche - Waterdichting",
  RoofTechnicalFileInsulation = "Dak - Technische fiche - Isolatie",
  RoofTechnicalFileRoofStructure = "Dak - Technische fiche - Dakstructuur",
  RoofTechnicalFileRoofCovering = "Dak - Technische fiche - Dakbedekking",
  RoofTechnicalFileRoofWindows = "Dak - Technische fiche - Dakramen",
  RoofWorkInvoices = "Dak - Facturen werken",
  RoofWorkOffers = "Dak - Offertes werken",
  PIDOverviewContractors = "Postinterventie - Overzicht aannemers",
  InsuranceFileCommunication = "Verzekeringsdossier - Communicatie verzekeringsmaatschappij",
  InsuranceFileCommunicationCounterparty = "Verzekeringsdossier - Communicatie tegenpartij",
  InsuranceFileExpertiseReport = "Verzekeringsdossier - Expertiseverslag",
  InsuranceFileInfringement = "Verzekeringsdossier - Schade ingebrekestelling",
  CleaningServiceContract = "Poetsdienst - Contract",
  PermitAssumptionProof = "Vermoeden van vergunning - bewijsstuk",
  FireSecurityReviewAndInspection = "Brandveiligheid - Nazicht en keuring",
  KeysKeyPlanInvoice = "Slotenplan - Sleutels - Factuur",
  ElectricityWorksInvoice = "Elektriciteit werken - Factuur",
  ElectricityWorksOffer = "Elektriciteit werken - Offerte",
  SanitoryWorksInvoice = "Sanitair werken - Factuur",
  SanitoryWorksOffer = "Sanitair werken - Offerte",
  PaintingWorksInvoice = "Schilderwerken - Factuur",
  FinalProvisionStatementNotaryDeed = "Aankoop - Eindafrekening notaris",
  SolarPanelsOffer = "Zonnepanelen - Offerte",
  SolarPanelsCalculationCapacity = "Zonnepanelen - Berekening capaciteit",
  SolarPanelsInvoice = "Zonnepanelen - Factuur",
  TransferEnergy = "Aankoop - Overdracht energie vorige eigenaar",
  TransferWater = "Aankoop - Overdracht water vorige eigenaar",
  RequestTakePublicDomain = "Aanvraag inname openbaar domein",
  SignalisationPermit = "Signalisatievergunning voor werken",
  OfferNewFrontDoor = "Offerte plaatsen nieuwe voordeur",
  InvoiceNewFrontDoor = "Factuur plaatsen nieuwe voordeur",
  OfferNewWindows = "Offerte plaatsen nieuwe ramen",
  InvoiceNewWindows = "Factuur plaatsen nieuwe ramen",
  RequestPermitAssumed = "Aanvraag vergund geacht - vermoeden van vergunning",
  CoverImage = "Cover foto",
  Communicatie = "Communicatie",
  BuildingCoverImage = "Cover foto gebouw",
  UnitCoverImage = "Cover foto unit",
  AcquisitionImages = "Acquisitiebeelden",
  FrontagePicture = "Foto voorgevel gebouw",
  SideFacadeLeftPicture = "Foto zijgevel links",
  SideFacadeRightPicture = "Foto zijgevel rechts",
  BackFacadePicture = "Foto achtergevel",
  MainRoofPicture = "Foto hoofddak",
  SideRoofPicture = "Foto bijdak",
  AsbestosMaterialsPicture = "Foto asbesthoudende materialen gebouw",
  MoistPicture = "Foto vochtproblemen gebouw",
  StabilityPictureCracksAndFissures = "Foto stabiliteit gebouw - scheuren of barsten",
  PictureStairsCommonHall = "Foto trappen gemeenschap",
  PictureElectricalInstallation = "Foto elektrische installatie gebouw",
  FotoWerfopvolging = "Foto werfopvolging",
  ElektriciteitFotosUitvoering = "Elektriciteit foto's uitvoering",
  ElevatorPicture = "Foto lift",
  SewagePicture = "Foto riolering",
  PictureGutter = "Foto dakgoot",
  PictureRainwaterPipe = "Foto regenwaterafvoer",
  PictureDoorbell = "Foto deurbel",
  PictureRenovationSiteMonitoring = "Foto Renovatie - Werfopvolging",
  WindowsFrontPicture = "Foto ramen voorgevel",
  WindowsBackPicture = "Foto ramen achtergevel",
  WindowsLeftPicture = "Foto ramen zijgevel links",
  WindowsRightPicture = "Foto ramen zijgevel rechts",
  PictureCellar = "Foto kelder",
  PictureWaterMeterBuilding = "Foto watermeter gebouw",
  PictureElectricityMeterBuilding = "Foto elektriciteitsmeter gebouw",
  PictureGasMeterBuilding = "Foto gasmeter gebouw",
  PictureGarage = "Foto garage",
  PictureHal = "Foto inkomhal",
  PictureKeyCard = "Foto sleutelkaart",
  PictureNeighboringBuildings = "Foto aangrenzende gebouwen",
  PictureNeighbourhood = "Foto omgeving",
  PictureCollectiveCentralHeatingBuilding = "Foto collectieve verwarmingsinstallatie gebouw",
  PictureFireSecurityBuilding = "Foto brandveiligheid gebouw",
  PictureAlarmInstallationBuilding = "Foto alarminstallatie gebouw",
  FrontagePictureUnit = "Foto voorgevel unit",
  DevicePictureUnit = "Foto toestel unit",
  MoistPictureUnit = "Foto vochtproblemen unit",
  AsbestosMaterialsPictureUnit = "Foto asbesthoudende materialen unit",
  StabilityPictureUnitCracksAndFissures = "Foto stabiliteit unit - scheuren of barsten",
  PictureBedrooms = "Foto slaapkamers",
  PictureBathroom = "Foto badkamer",
  PictureToilet = "Foto toilet",
  CeilingFloorWallsPicture = "Foto muren - ramen - plafond afwerking",
  PictureElectricalInstallationUnit = "Foto elektrische installatie unit",
  PictureClimatisationDevice = "Foto klimatisatie toestel",
  PictureKitchen = "Foto keuken",
  PictureLivingRoom = "Foto leefruimte",
  PictureStorage = "Foto berging",
  PictureCentralHeatingUnit = "Foto verwarmingsinstallatie unit",
  PictureWaterMeterUnit = "Foto watermeter unit",
  PictureElectricityMeterUnit = "Foto elektriciteitsmeter unit",
  PictureGasMeterUnit = "Foto gasmeter unit",
  PictureTerrace = "Foto terras",
  PictureGarden = "Foto tuin",
  PictureKeysFrontDoor = "Foto sleutel voordeur",
  PictureKeysApartment = "Foto sleutel appartement",
  PictureKeysLetterbox = "Foto sleutel brievenbus",
  PictureCommercialUnit = "Foto winkelruimte",
  PictureAlarmInstallationUnit = "Foto alarminstallatie unit",
  PictureFireSecurityUnit = "Foto brandveiligheid unit",
  Aannemers = "Aannemers",
  AsbestosRemovalInvoice = "Asbest factuur verwijdering",
  Gebouwfiche = "Gebouwfiche",
  TaxatieBerekeningen = "Berekeningen taxatie",
  OnderhandseOvereenkomst = "Onderhandse overeenkomst aankoop gebouw",
  Brandvoorschriften = "Brand voorschriften",
  ConformiteitsattestBrandveiligheid = "Conformiteitsattest brandveiligheid",
  Evacuatieplan = "Evacuatieplan",
  PVOvertredingBrand = "PV overtreding brand",
  EnergeticalDD = "Energetical DD",
  FinancialDD = "Financial DD",
  FiscalDD = "Fiscal DD",
  LegalDD = "Legal DD",
  TechnicalDD = "Technical DD",
  Financieel = "Financieel",
  AanslagbiljetOV = "Aanslagbiljet OV",
  AttestAankoop = "Attest aankoop",
  StabilityStudy = "Stabiliteit - Stabiliteitsstudie",
  StabilityCommunication = "Stabiliteit - Communicatie",
  StabilityReportVisit = "Stabiliteit - Rapportage plaatsbezoek",
  Basisakte = "Basisakte",
  Eigendomsakte = "Eigendomsakte",
  KadastraalInkomen = "Kadastraal inkomen",
  ReglementMedeEigendom = "Reglement mede eigendom",
  SchattingTaxatieverslag = "Schatting taxatieverslag",
  SPA = "SPA",
  EPBDossier = "EPB dossier",
  EPCCommon = "EPC gemeenschap",
  Renovaties = "Renovaties",
  CollectieveVerwarmingKeuringsattest = "Collectieve verwarming keuringsattest",
  CollectieveVerwarmingOnderhoudsattest = "Collectieve verwarming onderhoudsattest",
  CollectieveVerwarmingToestelfiche = "Collectieve verwarming toestelfiche",
  CollectieveVerwarmingFactuur = "Collectieve verwarming factuur",
  BBO = "BBO",
  Bodemattest = "Bodemattest",
  Grondanalyse = "Grondanalyse",
  Omgevingsvergunning = "Omgevingsvergunning",
  Bouwaanvraag = "Bouwaanvraag",
  Milieuvergunning = "Milieuvergunning",
  OBO = "OBO",
  Aanbesteding = "Aanbesteding",
  Budget = "Budget",
  Lastenboek = "Lastenboek",
  Materialenfiche = "Materialenfiche",
  RioleringKeuringsattest = "Keuringsattest riolering gebouw",
  Rioleringsplan = "Plan riolering",
  WaterKeuringBinneninstallatie = "Keuringsattest binneninstallatie water",
  Opleveringsverslag = "Opleveringsverslag werken",
  Veiligheidscoordinatie = "Verslag veiligheidscoordinatie",
  Werfverslag = "Werfverslag",
  ElektriciteitSituatieschetsBuilding = "Elektriciteit situatieschets gebouw",
  ElektriciteitEendraadsschemaGebouw = "Elektriciteit eendraadsschema gebouw",
  ElektriciteitAlgemeen = "Elektriciteit algemeen",
  ElektriciteitKeuringsattestGebouw = "Elektriciteit keuringsattest gebouw",
  Lift = "Lift",
  ElevatorRiskAnalysis = "Lift risicoanalyse",
  ElevatorMaintenanceContract = "Lift onderhoudscontract",
  ElevatorInspectionCertificate = "Lift keuringsattest",
  PlanCommercieel = "Plan commercieel",
  PlanKadaster = "Plan kadaster",
  PlanLandmeter = "Plan landmeter",
  PlanUitvoering = "Plan uitvoering",
  PlanVergunning = "Plan vergunning",
  PlanVoorontwerp = "Plan voorontwerp",
  PlanGeneriek = "Plan generiek",
  PlanVoorstelNieuweToestand = "Plan voorstel nieuwe toestand",
  Biedbrief = "Biedbrief",
  LOI = "LOI",
  Bouwvoorschriften = "Bouwvoorschriften",
  ConformiteitsattestStedenbouw = "Conformiteitsattest stedenbouw",
  PVOvertredingStedenbouw = "PV overtreding stedenbouw",
  StedenbouwkundigeInlichtingen = "Stedenbouwkundige inlichtingen",
  Vergunning = "Vergunning",
  Asbestattest = "Asbestattest gemeenschappelijke delen",
  Asbestinventaris = "Asbestinventaris",
  GevaarlijkeStoffen = "Gevaarlijke stoffen",
  ABRPolis = "ABR polis",
  VerzekeringCommunicatie = "Verzekering communicatie",
  Verzekeringsattest = "Verzekeringsattest",
  Verzekeringspolis = "Verzekeringspolis",
  OverigeToestellenGemeenschap = "Overige toestellen gemeenschap",
  Nutsvoorzieningen = "Nutsvoorzieningen",
  KadastraalUittreksel = "Kadastraal uittreksel",
  EPCUnit = "EPC unit",
  Huurcontract = "Huurcontract",
  AddendumHuurcontract = "Addendum aan huurcontract",
  GarageAddendumContract = "Garage addendum contract",
  AnnexHuurcontract = "Bijlage aan huurcontract",
  CommunicatieHuurder = "Communicatie huurder",
  BetalingsbewijsHuur = "Betalingsbewijs huur",
  BewijsVanWerk = "Bewijs van werk",
  BrandverzekeringHuurder = "Brandverzekering huurder",
  Huurhernieuwingsaanvraag = "Huurhernieuwingsaanvraag",
  Huurwaarborg = "Huurwaarborg",
  IdentiteitskaartHuurder = "Identiteitskaart huurder",
  Indexatiebrief = "Indexatiebrief",
  IngaandePlaatsbeschrijving = "Ingaande plaatsbeschrijving",
  Loonfiche = "Loonfiche",
  Opzegbrief = "Opzegbrief",
  RegistratiebewijsHuurcontract = "Registratiebewijs huurcontract",
  RegistratiebewijsPlaatsbeschrijving = "Registratiebewijs plaatsbeschrijving",
  ReglementInwendigeOrde = "Reglement inwendige orde",
  Sleuteloverdracht = "Sleuteloverdracht",
  UitgaandePlaatsbeschrijving = "Uitgaande plaatsbeschrijving",
  ElektriciteitSituatieschetsUnit = "Elektriciteit situatieschets unit",
  ElektriciteitEendraadsschemaUnit = "Elektriciteit eendraadsschema unit",
  ElektriciteitKeuringsattestUnit = "Elektriciteit keuringsattest unit",
  VerwarmingKeuringsattest = "Verwarming unit keuringsattest",
  VerwarmingOnderhoudsattest = "Verwarming unit onderhoudsattest",
  PlanUnitCommercieel = "Plan unit commercieel",
  PlanUnitHuidigeIndeling = "Plan unit huidige indeling",
  PlanUnitOntwerpNieuweIndeling = "Plan unit ontwerp nieuwe indeling",
  ConformiteitsattestUnit = "Conformiteitsattest unit",
  ToestelBestelbon = "Toestel bestelbon",
  ToestelFactuur = "Toestel factuur",
  ToestelFiche = "Toestel fiche",
  ToestelGarantiebewijs = "Toestel garantiebewijs",
  ToestelHandleiding = "Toestel handleiding",
  ToestelOfferte = "Toestel offerte",
}

export enum DocumentDigitalCompatibility {
  ORIGINAL_PDF = "Origineel PDF bestand (niet ingescand)",
  DWG = "DWG formaat",
  SCANNED = "Ingescand document",
  NOT_APPLICABLE = "Niet van toepassing",
}

export enum FileLogStatus {
  OK = "Ok",
  OK_WITH_REMARKS = "Ok, maar met opmerkingen",
  NOT_REQUIRED = "Niet nodig",
  NOT_OK = "Niet ok",
  UNKNOWN = "Onbekend of na te kijken",
}

export enum SignStatus {
  SIGNED = "Getekend",
  DRAFT = "Ontwerp",
  NOT_REQUIRED = "Niet van toepassing",
  UNKNOWN = "Onbekend / Na te kijken",
}

export enum EPCLabel {
  A_PLUS = "A+",
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  UNKNOWN = "Onbekend",
}

export enum WindowAdvice {
  HR_GLASS = "Plaatsen hoogrendementsbeglazing",
  WINDOW_PROFILES = "Plaatsen energiezuinige profielen",
  HR_GLASS_AND_PROFILES = "Plaatsen hoogrendementsbeglazing en energiezuinige profielen",
  UNKNOWN = "Onbekend",
}

export enum AirTightness {
  UNKNOWN = "Onbekend",
}

export enum CoolingAndSummerComfort {
  OK = "Geen oververhitting",
  NOT_OK = "Kans op oververhitting",
  UNKNOWN = "Onbekend",
}

export enum CoolingAndSummerComfortInstallation {
  NO_INSTALLATION = "Geen koel/aircoinstallatie aanwezig",
  UNKNOWN = "Onbekend",
}

export enum LedLighting {
  OK = "LED-verlichting aanwezig",
  NOT_OK = "Geen LED-verlichting aanwezig",
  UNKNOWN = "Onbekend",
}

export enum SanitaryHotWater {
  OK = "Aanwezig",
  COLLECTIVE_INSTALLATION = "Collectieve installatie aanwezig",
  UNKNOWN = "Onbekend",
}

export enum HeatingSystem {
  COLLECTIVE_INSTALLATION_CONDENSING = "Collectieve centrale installatie met condenserende ketel",
  UNKNOWN = "Onbekend",
}

export enum SolarBoiler {
  PRESENT = "Zonneboiler aanwezig",
  NOT_PRESENT = "Geen zonneboiler aanwezig",
  UNKNOWN = "Onbekend",
}

export enum SolarPanels {
  PRESENT = "Zonnepanelen aanwezig",
  NOT_PRESENT = "Geen zonnepanelen aanwezig",
  UNKNOWN = "Onbekend",
}

export enum VentilationSystemType {
  A = "A (Natuurlijke toevoer en afvoer)",
  B = "B (Mechanische toevoer)",
  C = "C (Mechanische afvoer)",
  C_PLUS = "C+ (Mechanische afvoer met vraagsturing)",
  D = "D (Mechanische toevoer en afvoer)",
  NOT_REQUIRED = "Niet verplicht",
  NOT_OK = "Verplicht, maar niet aanwezig",
  UNKNOWN = "Onbekend",
}

export type EPC = {
  id: number;
  epcLabel: EPCLabel;
  kWh: string | null;
  uValueWalls: number | null;
  uValueGlazing: number | null;
  uValueWindows: number | null;
  fileLogId: number | null;
  extraWallInsulationSqm: number | null;
  extraRoofInsulationSqm: number | null;
  extraFloorInsulationSqm: number | null;
  extraWindowAdvice: WindowAdvice;
  airTightness: AirTightness;
  coolingAndSummerComfort: CoolingAndSummerComfort;
  coolingAndSummerComfortInstallation: CoolingAndSummerComfortInstallation;
  coEmission: string | null;
  sScore: string | null;
  ledLighting: LedLighting;
  sanitaryHotWater: SanitaryHotWater;
  heatingSystem: HeatingSystem;
  solarBoiler: SolarBoiler;
  solarPanels: SolarPanels;
  ventilationSystemType: VentilationSystemType;
};

export type FileLog = {
  id?: number;
  fileLabel: FileLabel | string | null;
  secondaryLabels?: SecondaryLabel[];
  label?: any[];
  documentDigitalCompatibility?: DocumentDigitalCompatibility | null;
  summary?: string;
  documentDate?: Date | string | null;
  unitId?: string;
  status: FileLogStatus;
  statusDescription: string;
  buildingId?: string;
  building?: BuildingDTO;
  unit?: UnitDTO;
  resourceId?: string;
  signStatus: SignStatus;
  expirationDate?: Date | string | null;
  relations?: Resource[];
  referenceCode?: string;
  sharePointFileId?: string;
  sharePointFileUrl?: string;
  imageUrl?: string; // Image URL for photos (SharePoint download URL)
  thumbnailUrl?: string; // Thumbnail URL for photo previews
  s3Url?: string; // S3 URL for files stored in AWS
  createdAt?: Date;
  createdBy?: string | null | undefined;
  updatedAt?: Date;
  createdByUserId?: string | null | undefined;
  createdByUserFullName?: string | null | undefined;
  epc?: EPC | null; // EPC metadata with proper typing
  renovationProjectId?: number; // Link to renovation project
  projectPartId?: number; // Link to project part
  renovationProject?: { id: number; title: string }; // Populated renovation project object
  projectPart?: { id: number; title: string }; // Populated project part object
};
